import React from "react";
import { useLocation } from "react-router-dom";
import { useAppTranslation } from "@/utils/useAppTranslation";
import { LocationStateSearch } from "@/pages/Shop/Coupon/types";
import CustomCouponForm from "./forms";

const CreateCoupon: React.FC = () => {
  const location = useLocation();
  const locationSearch = (location.state as LocationStateSearch)?.locationSearch;
  const { t } = useAppTranslation();

  return <CustomCouponForm title={t("coupon.title")} locationSearch={locationSearch} />;
};

export default CreateCoupon;
